import { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'

import { useAppSelector } from 'app-redux/hooks'

export const collapsibleCategoryCookieKey = 'tbCollapsedCategories'

export function getCollapsedCategoryKey(name: string, deckId: number) {
  return `${deckId}-${name}`
}

export function categoriesCanCollapse(stack: number) {
  // only allow categories to collapse when grouped by Category or Categories (multiple)
  return stack === 0 || stack === 6
}

export const useCategoryIsCollapsed = (name: string): boolean => {
  const deckId = useAppSelector(state => state.deck.id)
  const stack = useAppSelector(state => state.deck.stack)

  const [{ tbCollapsedCategories = {} }] = useCookies([collapsibleCategoryCookieKey])
  const categoryKey = getCollapsedCategoryKey(name, deckId)
  const canCollapse = categoriesCanCollapse(stack)

  const [isCollapsed, setIsCollapsed] = useState<boolean>(tbCollapsedCategories[categoryKey])

  useEffect(() => {
    setIsCollapsed(!canCollapse ? false : tbCollapsedCategories[categoryKey])
  }, [tbCollapsedCategories, canCollapse, stack])

  return isCollapsed
}
